import { Koi } from '@ksyos/koi';
import { EpisodeCategory } from '@common/enums/episodeCategory';
import type { ISchemaContainer } from './schemaContainer';
import { DeviceAccessoryStatus } from '../enums/deviceAccessoryStatus';

export interface IDeviceAccessoryEditValidated {
    organizationId: string | null;
    status: DeviceAccessoryStatus;
}

export interface IDeviceAccessoryAddValidated extends IDeviceAccessoryEditValidated {
    deviceAccessoryTypeId: string;
    referenceNumber: string | null;
    serialNumber: string | null;
}

const deviceAccessoryEdit = Koi.object({
    organizationId: Koi.when('status', {
        is: DeviceAccessoryStatus.sent,
        otherwise: Koi.valid(null),
        then: Koi.string().uuid().allow(null),
    }),
    status: Koi.koi().enum(DeviceAccessoryStatus),
});

export interface IDeviceAccessoryFilters {
    endDate?: Date;
    episodeCategories?: EpisodeCategory[];
    searchText?: string | null;
    startDate?: Date;
}

export const deviceAccessoryFiltersSchema = Koi.object({
    endDate: Koi.koi().date().endDate().allow(null),
    episodeCategories: Koi.array().items(Koi.koi().enum(EpisodeCategory)).allow(null),
    searchText: Koi.string().max(255).allow(null, ''),
    startDate: Koi.koi().date().allow(null),
});

export const deviceAccessoryFiltersValidation: ISchemaContainer<IDeviceAccessoryFilters> = {
    schema: deviceAccessoryFiltersSchema,
};

export const deviceAccessoryAddSchema: ISchemaContainer<IDeviceAccessoryAddValidated> = {
    schema: deviceAccessoryEdit.keys({
        deviceAccessoryTypeId: Koi.string().uuid(),
        referenceNumber: Koi.string().max(30).allow(null),
        serialNumber: Koi.string().max(30).allow(null),
    }),
};

export const deviceAccessoryEditSchema: ISchemaContainer<IDeviceAccessoryEditValidated> = {
    schema: deviceAccessoryEdit,
};
